export enum FilterCategoryId {
  All = 1,
  CategoryOne = 2,
  CategoryTwo = 3,
}
